import { pxToRem, theme } from '@pocketlaw/tetris';
import styled, { css } from 'styled-components';
export const highlightStyles = css `
  color: ${theme.semantic.foreground.primary};

  &:not(:empty) {
    padding: ${pxToRem(1)};
    background-color: ${theme.swatches.yellow[200]};
    border-radius: ${pxToRem(1)};
  }
`;
export const Container = styled.span `
  ${highlightStyles};
`;
